import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { formatBytes } from "helpers/numberFormatting";

import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";

const MailDomainContainerRecap = ({
 server,
 name,
 comment,
 quota,
 users,
 aliases
}: {
 server: string;
 name: string;
 comment: string;
 quota: number;
 users: number;
 aliases: number;
}): ReactElement => {
 const formatQuota = (): string => {
  const tempQuota = quota * 1024 * 1024;
  if (tempQuota > 1048570 && tempQuota < 1073741824) return `${formatBytes(tempQuota, "MB")} MB`;
  else return `${formatBytes(tempQuota, "GB")} GB`;
 };

 return (
  <Paper
   elevation={1}
   sx={{
    p: 2,
    maxHeight: 580,
    position: "sticky",
    borderRadius: "5px"
   }}>
   <Stack alignItems="center" direction="row" spacing={1}>
    <IconSelector icon="DockerIcon" props={{ color: "kxOrange" }} />
    <Typography variant="unboundedTitle" fontWeight="bold" fontSize={18}>
     <FormattedMessage id="container.maildomains.add.recap" />
    </Typography>
   </Stack>
   <Divider sx={{ my: 1 }} />
   <Stack textAlign="left" mb={1}>
    <Typography variant="unboundedTitle" fontSize={14}>
     <FormattedMessage id="container.maildomains.add.serverData" />
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={120} textAlign="start" fontWeight="bold">
     <FormattedMessage id="container.maildomains.add.serverName" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {server}
    </Typography>
   </Stack>
   <Divider textAlign="left" sx={{ mt: 2 }}>
    <Typography variant="overline">
     <FormattedMessage id="container.maildomains.add.domainData" />
    </Typography>
   </Divider>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={120} textAlign="start" fontWeight="bold">
     <FormattedMessage id="container.maildomains.add.domainName" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {name}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={120} textAlign="start" fontWeight="bold">
     <FormattedMessage id="container.maildomains.add.comment" />:
    </Typography>
    <Stack direction="row" spacing={1} alignItems="center">
     <Typography variant="subtitle2" noWrap>
      {comment || "--"}
     </Typography>
    </Stack>
   </Stack>
   <Divider textAlign="left" sx={{ mt: 2 }}>
    <Typography variant="overline">
     <FormattedMessage id="container.maildomains.add.domainLimits" />
    </Typography>
   </Divider>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={120} textAlign="start" fontWeight="bold">
     <FormattedMessage id="container.maildomains.add.quotaLimit" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {formatQuota()}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={120} textAlign="start" fontWeight="bold">
     <FormattedMessage id="container.maildomains.add.usersLimit" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {users}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={120} textAlign="start" fontWeight="bold">
     <FormattedMessage id="container.maildomains.add.aliasesLimit" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {aliases}
    </Typography>
   </Stack>
  </Paper>
 );
};

export default MailDomainContainerRecap;
